import { DropArea, DROPAREA_PADDING, DropAreaWithPadding } from "@components/fileUploader";
import styled from "styled-components";

import View from "../View";

export const FileViewStyled = styled(View)`
    ${DropArea} {
        ${DropAreaWithPadding};
        margin-top: ${DROPAREA_PADDING}px;
    }
`;